<template>
	<div
		class="accordion-wrapper"
		:class="[
			spaceY,
			divideY,
			divideColor,
			doubleBorders ? borderTopBottom : borderBottom,
			borderColor,
		]"
	>
		<slot></slot>
	</div>
</template>

<script setup>
const props = defineProps({
	spaceY: {
		type: String,
		default: 'space-y-0',
		required: false,
	},
	divideY: {
		type: String,
		default: 'divide-y',
		required: false,
	},
	divideColor: {
		type: String,
		default: 'divide-gray-200',
		required: false,
	},
	borderTopBottom: {
		type: String,
		default: 'border-t border-b',
		required: false,
	},
	borderBottom: {
		type: String,
		default: 'border-b',
		required: false,
	},
	borderColor: {
		type: String,
		default: 'border-gray-200',
		required: false,
	},
	doubleBorders: {
		type: Boolean,
		default: false,
		required: false,
	},
})
</script>
